import { useLazyQuery } from '@apollo/client';
import PageLayout from 'components/layout/page-layout';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { makeStyles } from '@mui/styles';

import { Job, Query, QueryJobArgs } from '@libs/graphql-types';
import Typography from '@libs/ui/components/typography';

import FooterText from './footer-text';
import Intro from './intro';
import JobInfo from './job-info';
import { GET_JOB_INFO } from './queries';

const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    maxWidth: '100%',
    width: '100%',
  },
}));

export const JobDetails = () => {
  const classes = useStyles();
  const { t } = useTranslation('public');
  const params = useParams<{ id?: string }>();
  const jobId = params.id;
  const [request, { data, loading }] = useLazyQuery<Query, QueryJobArgs>(
    GET_JOB_INFO,
  );
  const job = data?.job as Job | undefined;

  useEffect(() => {
    if (jobId) {
      request({ variables: { id: jobId } });
    }
  }, [jobId, request]);

  if (!job) {
    return (
      <PageLayout
        classes={{ contentWrapper: classes.contentWrapper }}
        documentTitle={t('jobDetails.documentTitle')}
        isLoading={loading}
      >
        <Typography variant="h2">{t('jobDetails.notFoundCode')}</Typography>
        <Typography variant="h5">{t('jobDetails.notFound')}</Typography>
      </PageLayout>
    );
  }

  return (
    <PageLayout
      documentTitle={t('jobDetails.documentTitle')}
      isLoading={loading}
      centered
      classes={{ contentWrapper: classes.contentWrapper }}
    >
      <Intro job={job} />
      <JobInfo job={job} />
      <FooterText job={job} />
    </PageLayout>
  );
};
